import { useState } from "react";
import VideoList from "@admin/components/Videos/VideoList";
import VideoModal from "@admin/components/Modals/VideoModal";

const Videos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={openModal}>
          Add Video
        </button>
        <VideoModal open={isModalOpen} closeModal={closeModal} />
      </div>
      <VideoList />
    </div>
  );
};

export default Videos;
